import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
type UseCaseId = 'client-management' | 'growth-marketing' | 'founders-execs' | 'enterprise';
const USE_CASES: {
  id: UseCaseId;
  label: string;
  description: string;
  to: string;
}[] = [{
  id: 'founders-execs',
  label: 'Founders & Execs',
  description: 'Prep for meetings, sweep open loops, and stay on top of everything.',
  to: '/use-cases/founders-execs'
}, {
  id: 'client-management',
  label: 'Client Management',
  description: 'Prep every call, chase every invoice, close every loop.',
  to: '/use-cases/client-management'
}, {
  id: 'growth-marketing',
  label: 'Growth & Marketing',
  description: 'Reports, attribution, and spend — handled while you sleep.',
  to: '/use-cases/growth-marketing'
}, {
  id: 'enterprise',
  label: 'Enterprise',
  description: 'One shared brain for every department, at your security bar.',
  to: '/enterprise'
}];
/** Cross-navigation strip shown near the bottom of each use-case page so
 *  visitors who landed on the "wrong" use case stay in the funnel. Pass the
 *  current page id to hide it from its own list. */
export function UseCaseCrossLinks({
  current
}: {
  current: UseCaseId;
}) {
  const others = USE_CASES.filter(u => u.id !== current);
  return <section className="w-full bg-white border-t border-neutral-200 py-20 md:py-28" data-id="element-2995">
      <div className="max-w-[1200px] mx-auto px-6" data-id="element-2996">
        <span className="text-xs font-semibold tracking-[5px] uppercase text-neutral-400 mb-5 block" data-id="element-2997">
          More use cases
        </span>
        <h2 className="text-3xl md:text-4xl font-title font-bold tracking-tight text-[#2B211A] mb-10 md:mb-12" data-id="element-2998">
          Giga works the same way for every team.
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-5" data-id="element-2999">
          {others.map((u, i) => <motion.div key={u.id} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.45,
          delay: i * 0.08
        }} data-id="element-3000">
              <Link to={u.to} className="group flex items-center justify-between gap-6 rounded-2xl border border-neutral-200 bg-[#FAF8F4] hover:bg-white hover:border-[#EA580C]/30 hover:shadow-md transition-all duration-200 p-6 md:p-8" data-id="element-3001">
                <div data-id="element-3002">
                  <div className="font-title font-bold text-xl text-[#2B211A] mb-1.5" data-id="element-3003">
                    {u.label}
                  </div>
                  <p className="text-[15px] text-neutral-600 leading-relaxed" data-id="element-3004">
                    {u.description}
                  </p>
                </div>
                <span className="shrink-0 w-10 h-10 rounded-full bg-white border border-neutral-200 group-hover:bg-[#EA580C] group-hover:border-[#EA580C] flex items-center justify-center text-[#2B211A] group-hover:text-white transition-colors duration-200" data-id="element-3005">
                  <ArrowRight size={18} data-id="element-3006" />
                </span>
              </Link>
            </motion.div>)}
        </div>
      </div>
    </section>;
}